import React from 'react';
import { Box } from '../element';

const TwoColumnLayout = ({ leftNavClassName, rightContentClassName, ...props }) => (
  <Box direction="row" fill={true} className="pageWrapper">
    <Box direction="row" className={leftNavClassName}>
      <Box fill="horizontal">{props.sideMenu}</Box>
    </Box>
    <Box wrap={true} direction="row" fill={true} className={rightContentClassName}>
      {props.children}
    </Box>
  </Box>
);

export default TwoColumnLayout;
